import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError } from '../../models/http';
import { PREDEF_ANSWERS_ROUTE } from '../configs/predef-answers-api';
import {
	PredefinedAnswer,
	PredefinedAnswersGetListRequest,
	PredefinedAnswersGetListResponse,
} from '../models/payload-parts';

export const getAnswerList = async (
	params?: PredefinedAnswersGetListRequest,
): Promise<PredefinedAnswer[]> => {
	const response = await axios.get<PredefinedAnswersGetListResponse>(
		PREDEF_ANSWERS_ROUTE.GET_LIST,
		{ params },
	);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data.responsePayload;
};
